import { useEffect, useRef } from 'react';

export type HotkeyMap = Record<string, (e: KeyboardEvent) => void>;

/** Chuẩn hóa phím: "F4", "ctrl+s", "alt+n", "shift+F9"... */
function keyOf(e: KeyboardEvent) {
  const parts: string[] = [];
  if (e.ctrlKey || e.metaKey) parts.push('ctrl');
  if (e.altKey) parts.push('alt');
  if (e.shiftKey) parts.push('shift');
  const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
  parts.push(k);
  return parts.join('+');
}

/**
 * Gắn phím tắt cấp trang. Chặn hành vi mặc định của trình duyệt (F5 tải lại, F10 menu...).
 * enabled=false khi có dialog mở để phím tắt không chạy chồng.
 */
export function useHotkeys(map: HotkeyMap, enabled = true) {
  const ref = useRef(map);
  ref.current = map;
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      const fn = ref.current[keyOf(e)];
      if (fn) {
        e.preventDefault();
        e.stopPropagation();
        fn(e);
      }
    };
    window.addEventListener('keydown', handler, { capture: true });
    return () => window.removeEventListener('keydown', handler, { capture: true });
  }, [enabled]);
}
